import React, { useMemo, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import Layout from "../../layout/Layout";
import {
  compareMakinaExcelDebug,
  insertMakinaExcelPaste,
} from "../../../api/uretim/makineDataApi";

const DEFAULT_EXCEL_HEADERS = [
  "FORM NO",
  "İŞ EMRİ NO",
  "GÜN",
  "AY",
  "TARİH",
  "VRD",
  "OPERATÖR",
  "MALZEME CİNSİ",
  "KALINLIK",
  "EN1",
  "EN2",
  "BOY",
  "BANT ENİ",
  "BAĞ İÇİ",
  "FİRMA",
  "HEDEF HIZ",
  "HEDEF PAKET DOLUM SÜRESİ",
  "KG/M FORMUL",
  "HEDEF ÜRETİM FORMUL",
  "HIZ FORMUL",
  "TESTERE KIRILMASI",
  "GERÇEKLEŞEN HIZ",
  "PAKET DOLUM SÜRESİ FORMUL",
  "MAMUL BAĞ ADETİ",
  "MAMUL YARIM BAĞ",
  "MAMUL MİKTARI KG",
  "METRAJ FORMUL",
  "ALTERNATİF BAĞ ADETİ",
  "ALTERNATİF YARIM BAĞ",
  "ALTERNATİF KG",
  "ALTERNATİF YÜZDE FORMUL",
  "ALTERNATİF METRAJ FORMUL",
  "ÜRETİM FORMUL",
  "ISKARTA KG",
  "ISKARTA ADET FORMUL",
  "ISKARTA YÜZDE FORMUL",
  "ISKARTA METRAJ FORMUL",
  "TOPLAM ÜRETİM FORMUL",
  "TOPLAM METRAJ FORMUL",
  "KG/M 2 FORMUL",
  "AKÜMÜLASYON",
  "YIĞMA",
  "FORM DURUŞ",
  "KAYNAK",
  "ELEKTRİK KESİNTİSİ",
  "ELEKTRİK ARIZASI",
  "GALVANİZ ÜNİTESİ",
  "KALİBRE TÜRK KAFALARI",
  "YAĞLAMA",
  "RULMAN DEĞİŞİMİ",
  "TESTERE ARIZASI",
  "MAKARA DEĞİŞİMİ",
  "EBAT AYARI",
  "İSTİF",
  "İŞ EMRİ YOK",
  "PERSONEL EKSİKLİĞİ",
  "YÜKLEME YAPILMASI",
  "KALIP DEĞİŞİMİ",
  "TESTERE DEĞİŞİMİ",
  "TOPLANTI EĞİTİM",
  "SERVİS GEÇ GELMESİ",
  "VİNÇ BEKLEME",
  "DİĞER SEBEPLER",
  "YEMEK ÇAY MOLASI",
  "DURUŞLAR TOPLAMI FORMUL",
  "FİİLİ ÇALIŞMA SÜRESİ",
  "VERİM FORMUL",
];

const FIELD_LABELS = {
  akumulasyon: "Akümülasyon",
  alternatifBagAdeti: "Alternatif Bağ Adeti",
  alternatifKg: "Alternatif Miktar (KG)",
  alternatifMetraj: "Alternatif Metraj",
  alternatifYarimBag: "Alternatif Yarım Bağ",
  alternatifYuzde: "Alternatif Yüzde",
  bagIci: "Bağ İçi",
  bantEni: "Bant Eni",
  boy: "Boy",
  elektrikArizasi: "Elektrik Arızası",
  elektrikKesintisi: "Elektrik Kesintisi",
  en1: "En1",
  en2: "En2",
  ebatAyari: "Ebat Ayarı",
  fiiliCalismaSuresi: "Fiili Çalışma Süresi",
  firma: "Firma",
  formNo: "Form No",
  formDurus: "Form Duruş",
  galvenizUnitesi: "Galvaniz Ünitesi",
  gerceklesenHiz: "Gerçekleşen Hız",
  hedefHiz: "Hedef Hız",
  hedefPaketDolumSuresi: "Hedef Paket Dolum Süresi",
  hedefUretim: "Hedef Üretim",
  isEmriNo: "İş Emri No",
  iskartaAdet: "İskarta Adet",
  iskartaKg: "İskarta (KG)",
  iskartaMetraj: "İskarta Metraj",
  iskartaYuzde: "İskarta Yüzde",
  istif: "İstif",
  kalinlik: "Kalınlık",
  kalibreTurkKafalari: "Kalibre + Türk Kafaları",
  kalipDegisimi: "Kalıp Değişimi",
  kaynak: "Kaynak",
  kgM: "KG/M",
  makinaAdi: "Makina",
  makaraDegisimi: "Makara Değişimi",
  malzemeCinsi: "Malzeme Cinsi",
  mamulBagAdeti: "Mamül Bağ Adeti",
  mamulMiktariKg: "Mamül Miktarı (KG)",
  mamulYarimBag: "Mamül Yarım Bağ",
  metraj: "Metraj",
  operator: "Operatör",
  paketDolumSuresi: "Paket Dolum Süresi",
  personelEksikligi: "Personel Eksikliği",
  raporTarihi: "Rapor Tarihi",
  rulmanDegisimi: "Rulman Değişimi",
  servisGecGelmesi: "Servis Geç Gelmesi",
  tarih: "Tarih",
  testereArizasi: "Testere Arızası",
  testereDegisimi: "Testere Değişimi",
  testereKirilmasi: "Testere Kırılması",
  toplamiMetraj: "Toplam Metraj",
  toplamUretim: "Toplam Üretim (KG)",
  toplantiEgitim: "Toplantı / Eğitim",
  uretim: "Üretim (KG)",
  vardiya: "Vardiya",
  verim: "Verim",
  vincBekleme: "Vinç Bekleme",
  yaglama: "Yağlama",
  yemekCayMolasi: "Yemek / Çay Molası",
  yigma: "Yığma",
  yuklemeYapilmasi: "Yükleme",
};

function hasExcelHeader(text) {
  const firstLine = String(text || "").split(/\r?\n/)[0] || "";
  const upper = firstLine.toLocaleUpperCase("tr-TR");

  return upper.includes("FORM NO") || upper.includes("İŞ EMRİ NO");
}

function normalizeSheetCell(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/\r?\n/g, " ").trim();
}

function hasMeaningfulExcelData(row = []) {
  const firstColumns = row.slice(0, 8).map(normalizeSheetCell);
  return firstColumns.some((value) => value !== "");
}

function buildRawTextFromExcelRows(rows = []) {
  const normalizedRows = rows
    .map((row) =>
      Array.from({ length: DEFAULT_EXCEL_HEADERS.length }, (_, index) =>
        normalizeSheetCell(row[index])
      )
    )
    .filter((row) => hasMeaningfulExcelData(row));

  if (!normalizedRows.length) return "";

  const firstRowText = normalizedRows[0].join("\t");
  const dataRows = hasExcelHeader(firstRowText)
    ? normalizedRows.slice(1)
    : normalizedRows;

  if (!dataRows.length) return "";

  return `${DEFAULT_EXCEL_HEADERS.join("\t")}\n${dataRows
    .map((row) => row.join("\t"))
    .join("\n")}`;
}

function buildStructuredRowsFromExcelRows(rows = []) {
  const normalizedRows = rows
    .map((row) =>
      Array.from({ length: DEFAULT_EXCEL_HEADERS.length }, (_, index) =>
        normalizeSheetCell(row[index])
      )
    )
    .filter((row) => hasMeaningfulExcelData(row));

  if (!normalizedRows.length) return [];

  const firstRowText = normalizedRows[0].join("\t");
  const dataRows = hasExcelHeader(firstRowText)
    ? normalizedRows.slice(1)
    : normalizedRows;

  return dataRows.map((row) =>
    DEFAULT_EXCEL_HEADERS.reduce((acc, header, index) => {
      acc[header] = row[index] ?? "";
      return acc;
    }, {})
  );
}

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("tr-TR");
}

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") return value.toLocaleString("tr-TR");
  if (typeof value === "boolean") return value ? "Evet" : "Hayır";
  return String(value);
}

function getFieldLabel(fieldName) {
  if (!fieldName) return "-";
  if (FIELD_LABELS[fieldName]) return FIELD_LABELS[fieldName];

  return fieldName
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getBaseRowInfo(row = {}) {
  const payload = row.payload || row.normalizedRow || {};

  return {
    rowNumber: row.rowNumber,
    formNo: row.formNo || payload.formNo || row.normalizedRow?.formNo,
    isEmriNo: row.isEmriNo || payload.isEmriNo || row.normalizedRow?.isEmriNo,
    tarih: row.tarih || payload.tarih || row.normalizedRow?.tarih,
    operator: row.operator || payload.operator || row.normalizedRow?.operator,
    vardiya: row.vardiya || payload.vardiya || row.normalizedRow?.vardiya,
    firma: payload.firma || row.normalizedRow?.firma,
  };
}

function upsertIssueRow(targetMap, row, issue) {
  const base = getBaseRowInfo(row);
  const key = `${base.rowNumber}-${base.formNo || "bos"}`;

  if (!targetMap.has(key)) {
    targetMap.set(key, {
      ...base,
      issues: [],
      details: [],
    });
  }

  const entry = targetMap.get(key);

  if (!entry.issues.some((item) => item.label === issue.label)) {
    entry.issues.push({
      label: issue.label,
      tone: issue.tone,
    });
  }

  issue.details.forEach((detail) => {
    if (detail && !entry.details.includes(detail)) {
      entry.details.push(detail);
    }
  });
}

function SummaryCard({ title, value, tone = "light", subtitle }) {
  const borderClass =
    tone === "danger"
      ? "border-danger"
      : tone === "warning"
        ? "border-warning"
        : tone === "success"
          ? "border-success"
          : tone === "info"
            ? "border-info"
            : "";

  const textClass =
    tone === "danger"
      ? "text-danger"
      : tone === "warning"
        ? "text-warning"
        : tone === "success"
          ? "text-success"
          : tone === "info"
            ? "text-info"
            : "";

  return (
    <Card className={`shadow-sm h-100 ${borderClass}`}>
      <Card.Body>
        <div className="text-muted small">{title}</div>
        <div className={`fs-4 fw-bold ${textClass}`}>{value}</div>
        {subtitle ? <div className="small text-muted mt-1">{subtitle}</div> : null}
      </Card.Body>
    </Card>
  );
}

function SectionCard({ title, count, tone = "light", children, subtitle }) {
  return (
    <Card className="shadow-sm mb-4">
      <Card.Body>
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
          <div className="fw-semibold">{title}</div>
          <Badge bg={tone}>{count}</Badge>
        </div>
        {subtitle ? <div className="small text-muted mb-3">{subtitle}</div> : null}
        {children}
      </Card.Body>
    </Card>
  );
}

function ProblemTable({ rows, emptyText }) {
  if (!rows.length) {
    return <div className="text-muted small py-3">{emptyText}</div>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <Table bordered hover responsive className="align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th>Satır</th>
            <th>Sorun</th>
            <th>Form No</th>
            <th>İş Emri</th>
            <th>Tarih</th>
            <th>Operatör</th>
            <th>Detay</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.rowNumber}-${row.formNo || "bos"}`}>
              <td className="fw-semibold">{row.rowNumber}</td>
              <td style={{ minWidth: 180 }}>
                <div className="d-flex flex-wrap gap-2">
                  {row.issues.map((issue) => (
                    <Badge key={`${row.rowNumber}-${issue.label}`} bg={issue.tone}>
                      {issue.label}
                    </Badge>
                  ))}
                </div>
              </td>
              <td>{formatValue(row.formNo)}</td>
              <td>{formatValue(row.isEmriNo)}</td>
              <td>{formatDate(row.tarih)}</td>
              <td>{formatValue(row.operator)}</td>
              <td style={{ minWidth: 320 }}>
                {row.details.map((detail) => (
                  <div key={`${row.rowNumber}-${detail}`} className="small mb-1">
                    {detail}
                  </div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

function MakinaExcelImportKontrolPage() {
  const [pasteText, setPasteText] = useState("");
  const [pasteMakina, setPasteMakina] = useState("1");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileRowCount, setSelectedFileRowCount] = useState(0);
  const [saveLoading, setSaveLoading] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveSummary, setSaveSummary] = useState(null);
  const [saveErrorDetails, setSaveErrorDetails] = useState(null);
  const [parsedExcelRows, setParsedExcelRows] = useState([]);

  const summary = result?.summary || null;
  const invalidRows = useMemo(() => result?.invalidRows || [], [result]);
  const localDuplicateRows = useMemo(
    () => result?.localDuplicateRows || [],
    [result]
  );
  const exactExcelDuplicateRows = useMemo(
    () => result?.exactExcelDuplicateRows || [],
    [result]
  );
  const sameContentDifferentFormNoExcelRows = useMemo(
    () => result?.sameContentDifferentFormNoExcelRows || [],
    [result]
  );
  const changedInSystemRows = useMemo(
    () => result?.changedInSystemRows || [],
    [result]
  );
  const unchangedRows = useMemo(() => result?.unchangedRows || [], [result]);
  const sameContentDifferentFormNoDbRows = useMemo(
    () => result?.sameContentDifferentFormNoDbRows || [],
    [result]
  );

  const blockingProblemRows = useMemo(() => {
    const issueMap = new Map();

    invalidRows.forEach((row) => {
      upsertIssueRow(issueMap, row, {
        label: "Validasyon Hatası",
        tone: "danger",
        details: (row.errors || []).map((errorText) => `Hata: ${errorText}`),
      });
    });

    localDuplicateRows.forEach((row) => {
      upsertIssueRow(issueMap, row, {
        label: "Aynı Form No",
        tone: "danger",
        details: [
          `Excel içinde aynı Form No tekrar ediyor: ${formatValue(row.formNo)}`,
        ],
      });
    });

    exactExcelDuplicateRows.forEach((row) => {
      const matchingRows = (row.duplicateRowNumbers || [])
        .filter((item) => item !== row.rowNumber)
        .join(", ");

      upsertIssueRow(issueMap, row, {
        label: "Birebir Aynı Satır",
        tone: "dark",
        details: [
          matchingRows
            ? `Birebir aynı satır(lar): ${matchingRows}`
            : "Birebir aynı satır tespit edildi.",
        ],
      });
    });

    sameContentDifferentFormNoExcelRows.forEach((row) => {
      const matchingRows = (row.duplicateRowNumbers || [])
        .filter((item) => item !== row.rowNumber)
        .join(", ");
      const matchingFormNos = (row.matchingFormNos || [])
        .filter((item) => item !== row.formNo)
        .join(", ");

      upsertIssueRow(issueMap, row, {
        label: "İçerik Aynı / Form No Farklı",
        tone: "warning",
        details: [
          matchingRows
            ? `Aynı içerikteki diğer satırlar: ${matchingRows}`
            : "Aynı içerikte başka satır var.",
          matchingFormNos
            ? `Diğer Form No'lar: ${matchingFormNos}`
            : "Form No farkı tespit edildi.",
        ],
      });
    });

    return Array.from(issueMap.values()).sort(
      (a, b) => Number(a.rowNumber || 0) - Number(b.rowNumber || 0)
    );
  }, [
    invalidRows,
    localDuplicateRows,
    exactExcelDuplicateRows,
    sameContentDifferentFormNoExcelRows,
  ]);

  const systemWarningRows = useMemo(() => {
    const issueMap = new Map();

    changedInSystemRows.forEach((row) => {
      const fieldDetails = (row.changedFields || []).map(
        (field) =>
          `${getFieldLabel(field.field)}: Sistem ${formatValue(
            field.oldValue
          )} | Excel ${formatValue(field.newValue)}`
      );

      upsertIssueRow(issueMap, row, {
        label: "Sistemde Aynı Form No Var",
        tone: "warning",
        details: fieldDetails.length
          ? fieldDetails
          : ["Sistemde aynı Form No var ama alan farkı detayı boş geldi."],
      });
    });

    unchangedRows.forEach((row) => {
      upsertIssueRow(issueMap, row, {
        label: "Sistemde Aynı Kayıt Var",
        tone: "secondary",
        details: ["Bu satır sistemde zaten aynı şekilde kayıtlı."],
      });
    });

    sameContentDifferentFormNoDbRows.forEach((row) => {
      const matchingFormNos = (row.matchingDocs || [])
        .map((item) => item.formNo)
        .filter(Boolean)
        .join(", ");

      upsertIssueRow(issueMap, row, {
        label: "Sistemde İçerik Aynı",
        tone: "info",
        details: [
          matchingFormNos
            ? `Sistemde aynı içerikte farklı Form No'lar: ${matchingFormNos}`
            : "Sistemde formNo farklı ama içerik aynı kayıt bulundu.",
        ],
      });
    });

    return Array.from(issueMap.values()).sort(
      (a, b) => Number(a.rowNumber || 0) - Number(b.rowNumber || 0)
    );
  }, [changedInSystemRows, unchangedRows, sameContentDifferentFormNoDbRows]);

  const excelDuplicateCount =
    localDuplicateRows.length +
    exactExcelDuplicateRows.length +
    sameContentDifferentFormNoExcelRows.length;

  const canBeSavedAfterCleanup = Boolean(
    summary &&
      summary.validRows > 0 &&
      blockingProblemRows.length === 0
  );

  const cleanRowCount = Math.max(
    0,
    (summary?.totalRows || 0) - blockingProblemRows.length
  );

  const handleCompare = async () => {
    try {
      setLoading(true);
      setError("");
      setResult(null);
      setSaveMessage("");
      setSaveSummary(null);
      setSaveErrorDetails(null);

      if (!parsedExcelRows.length) {
        setError("Lütfen Excel dosyasını yükleyin.");
        return;
      }

      const res = await compareMakinaExcelDebug({
        makinaAdi: Number(pasteMakina),
        rows: parsedExcelRows,
      });

      setResult(res.data?.data || null);
    } catch (err) {
      console.error("Excel import kontrol hatası:", err);
      setSaveErrorDetails(null);
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.msg ||
          "Excel verisi kontrol edilirken hata oluştu."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleExcelFileChange = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      setLoading(true);
      setError("");
      setResult(null);
      setSaveMessage("");
      setSaveSummary(null);
      setSaveErrorDetails(null);
      setParsedExcelRows([]);

      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, {
        type: "array",
        cellFormula: false,
        cellHTML: false,
        cellText: true,
      });

      const firstSheetName = workbook.SheetNames?.[0];

      if (!firstSheetName) {
        setError("Excel içinde okunabilir sayfa bulunamadı.");
        return;
      }

      const worksheet = workbook.Sheets[firstSheetName];
      const sheetRows = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
        defval: "",
        blankrows: false,
      });

      const structuredRows = buildStructuredRowsFromExcelRows(sheetRows);
      const rawText = buildRawTextFromExcelRows(sheetRows);

      if (!structuredRows.length || !rawText) {
        setError("Excel dosyasında aktarılabilecek veri satırı bulunamadı.");
        return;
      }

      const dataLines = rawText.split(/\r?\n/).slice(1);

      setSelectedFileName(file.name);
      setSelectedFileRowCount(structuredRows.length);
      setParsedExcelRows(structuredRows);
      setPasteText(dataLines.join("\n"));
    } catch (err) {
      console.error("Excel dosyası okunamadı:", err);
      setError("Excel dosyası okunurken hata oluştu.");
    } finally {
      event.target.value = "";
      setLoading(false);
    }
  };

  const handleSaveToTestDb = async () => {
    try {
      setSaveLoading(true);
      setError("");
      setSaveMessage("");
      setSaveSummary(null);
      setSaveErrorDetails(null);

      if (!parsedExcelRows.length) {
        setError("Lütfen önce Excel dosyasını yükleyin.");
        return;
      }

      const res = await insertMakinaExcelPaste({
        makinaAdi: Number(pasteMakina),
        rows: parsedExcelRows,
        dryRun: false,
      });

      const responseData = res.data?.data || {};

      setSaveSummary(responseData.summary || null);
      setSaveErrorDetails(null);
      setSaveMessage(
        res.data?.message || "Veriler test veritabanına başarıyla kaydedildi."
      );
    } catch (err) {
      console.error("Excel test veritabanı kayıt hatası:", err);
      setSaveErrorDetails(err?.response?.data?.data || null);
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.msg ||
          "Veriler test veritabanına kaydedilirken hata oluştu."
      );
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Layout>
      <div className="d-flex flex-wrap align-items-end justify-content-between gap-3 mb-4">
        <div>
          <h2 className="fw-bold mb-1">Excel İçe Aktarım Kontrol</h2>
          <div className="text-muted small">
            Bu ekran kayıt yapmaz. Hangi satırda problem olduğunu satır bazında
            gösterir.
          </div>
        </div>

        <Form.Select
          value={pasteMakina}
          onChange={(e) => setPasteMakina(e.target.value)}
          style={{ width: 180 }}
        >
          <option value="1">Makina 1</option>
          <option value="2">Makina 2</option>
          <option value="3">Makina 3</option>
          <option value="4">Makina 4</option>
        </Form.Select>
      </div>

      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row className="g-3 mb-3">
            <Col lg={6}>
              <Form.Label className="fw-semibold">Excel Dosyası Yükle</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls,.xlsm"
                onChange={handleExcelFileChange}
                disabled={loading}
              />
              <div className="small text-muted mt-2">
                `xlsx`, `xls` ve `xlsm` dosyalarını okuyabilir. İlk sayfayı alır ve
                satırları doğrudan backend'e `rows` olarak gönderir. Copy-paste
                kaymasını önlemek için bu sayfa dosya odaklı çalışır.
              </div>
            </Col>
            <Col lg={6}>
              <div className="border rounded p-3 h-100 bg-light-subtle">
                <div className="small text-muted mb-1">Yüklenen Dosya</div>
                <div className="fw-semibold">
                  {selectedFileName || "Henüz dosya seçilmedi"}
                </div>
                <div className="small text-muted mt-2">
                  Hazırlanan veri satırı: {selectedFileRowCount || 0}
                </div>
              </div>
            </Col>
          </Row>

          <div className="fw-semibold mb-2">Excel Önizleme</div>
          <Form.Control
            as="textarea"
            rows={10}
            value={pasteText}
            readOnly
            placeholder="Excel dosyasını yüklediğinde önizleme burada görünür."
            style={{ fontFamily: "monospace", fontSize: 13, whiteSpace: "pre" }}
          />

          <div className="small text-muted mt-3">
            Bu alan artık sadece önizleme içindir. Kontrol ve kayıt işlemleri,
            yüklenen Excel dosyasından parse edilen satırlar ile yapılır.
          </div>

          {error ? (
            <Alert variant="danger" className="mt-3 mb-0">
              <div className="fw-semibold mb-1">{error}</div>
              {saveErrorDetails?.summary ? (
                <div className="small mb-2">
                  Yeni Satır: {saveErrorDetails.summary.insertableRows || 0} |
                  Sistemde Aynı: {saveErrorDetails.summary.unchangedRows || 0} |
                  Güncellenecek:{" "}
                  {saveErrorDetails.summary.updateableRows || 0}
                </div>
              ) : null}
              {saveErrorDetails?.hint ? (
                <div className="small mb-2">{saveErrorDetails.hint}</div>
              ) : null}
              {saveErrorDetails?.duplicateDetails?.sampleRows?.length ? (
                <div className="small">
                  İlk çakışmalar:{" "}
                  {saveErrorDetails.duplicateDetails.sampleRows
                    .map((item) => {
                      const row = item.row || {};
                      return `Satır ${
                        item.index !== undefined ? item.index + 1 : "?"
                      } / Makina ${row.makinaAdi || "-"} / Form No ${
                        row.formNo || "-"
                      } / Tarih ${formatDate(row.tarih)}`;
                    })
                    .join(" | ")}
                </div>
              ) : null}
            </Alert>
          ) : null}

          {saveMessage ? (
            <Alert variant="success" className="mt-3 mb-0">
              <div className="fw-semibold mb-1">{saveMessage}</div>
              {saveSummary ? (
                <div className="small mb-0">
                  Eklenen: {saveSummary.insertedRows || 0} | Güncellenen:{" "}
                  {saveSummary.updatedRows || 0} | Geçerli Satır:{" "}
                  {saveSummary.validRows || 0} | Okunan Satır:{" "}
                  {selectedFileRowCount || 0}
                </div>
              ) : null}
            </Alert>
          ) : null}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button
              variant="outline-secondary"
              onClick={() => {
                setPasteText("");
                setResult(null);
                setError("");
                setSaveMessage("");
                setSaveSummary(null);
                setSaveErrorDetails(null);
                setSelectedFileName("");
                setSelectedFileRowCount(0);
                setParsedExcelRows([]);
              }}
              disabled={loading || saveLoading}
            >
              Temizle
            </Button>
            <Button
              variant="primary"
              onClick={handleCompare}
              disabled={loading || saveLoading || !parsedExcelRows.length}
            >
              {loading ? "Kontrol Ediliyor..." : "Satırları Kontrol Et"}
            </Button>
            <Button
              variant="success"
              onClick={handleSaveToTestDb}
              disabled={
                loading ||
                saveLoading ||
                !parsedExcelRows.length ||
                !summary ||
                !canBeSavedAfterCleanup
              }
            >
              {saveLoading ? "Test DB'ye Kaydediliyor..." : "Test DB'ye Kaydet"}
            </Button>
          </div>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" />
        </div>
      ) : null}

      {summary ? (
        <>
          <Alert
            variant={canBeSavedAfterCleanup ? "success" : "danger"}
            className="mb-4"
          >
            <div className="fw-semibold mb-1">
              {canBeSavedAfterCleanup
                ? "Kayda engel satır bulunmadı."
                : `${blockingProblemRows.length} satırda kayda engel problem bulundu.`}
            </div>
            <div className="small mb-0">
              Buradaki kırmızı ve koyu etiketli satırlar temizlenmeden import
              yapmaman gerekir. Sarı ve mavi sistem uyarıları ise senin silip
              yeniden ekleme senaryonda bilgi amaçlıdır.
            </div>
          </Alert>

          <Row className="g-3 mb-4">
            <Col md={3}>
              <SummaryCard title="Toplam Satır" value={summary.totalRows} />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="Sorunsuz Satır"
                value={cleanRowCount}
                tone={cleanRowCount > 0 ? "success" : "warning"}
              />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="Kayda Engel Satır"
                value={blockingProblemRows.length}
                tone={blockingProblemRows.length > 0 ? "danger" : "success"}
              />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="Sistem Uyarısı"
                value={systemWarningRows.length}
                tone={systemWarningRows.length > 0 ? "warning" : "info"}
                subtitle="Bilgi amaçlı"
              />
            </Col>
          </Row>

          <Row className="g-3 mb-4">
            <Col md={3}>
              <SummaryCard
                title="Validasyon Hatası"
                value={invalidRows.length}
                tone={invalidRows.length > 0 ? "danger" : "success"}
              />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="Aynı Form No"
                value={localDuplicateRows.length}
                tone={localDuplicateRows.length > 0 ? "danger" : "success"}
              />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="Birebir Aynı Satır"
                value={exactExcelDuplicateRows.length}
                tone={exactExcelDuplicateRows.length > 0 ? "danger" : "success"}
              />
            </Col>
            <Col md={3}>
              <SummaryCard
                title="İçerik Aynı / FormNo Farklı"
                value={sameContentDifferentFormNoExcelRows.length}
                tone={
                  sameContentDifferentFormNoExcelRows.length > 0
                    ? "warning"
                    : "success"
                }
                subtitle={`Toplam Excel duplicate: ${excelDuplicateCount}`}
              />
            </Col>
          </Row>

          <Row className="g-3 mb-4">
            <Col md={4}>
              <SummaryCard
                title="Yeni Satır"
                value={summary.insertableRows}
                tone={summary.insertableRows > 0 ? "info" : "success"}
                subtitle="Sistemde bulunmayan"
              />
            </Col>
            <Col md={4}>
              <SummaryCard
                title="Sistemde Aynı"
                value={summary.unchangedRows}
                tone={summary.unchangedRows > 0 ? "secondary" : "success"}
                subtitle="Aynen kayıtlı"
              />
            </Col>
            <Col md={4}>
              <SummaryCard
                title="Güncellenecek"
                value={summary.updateableRows}
                tone={summary.updateableRows > 0 ? "warning" : "success"}
                subtitle="Aynı formNo, farklı içerik"
              />
            </Col>
          </Row>

          <SectionCard
            title="Kayda Engel Olan Satırlar"
            count={blockingProblemRows.length}
            tone="danger"
            subtitle="Önce buraya bak. Bu tablo sana doğrudan hangi satırda ne problem olduğunu söyler."
          >
            <ProblemTable
              rows={blockingProblemRows}
              emptyText="Kayda engel bir satır bulunmadı."
            />
          </SectionCard>

          <SectionCard
            title="Sistem Uyarıları"
            count={systemWarningRows.length}
            tone="warning"
            subtitle="Bunlar sen makineyi silip yeniden yükleyeceğin için bloklayıcı değil. Sadece sistemde ne olduğunu gösterir."
          >
            <ProblemTable
              rows={systemWarningRows}
              emptyText="Sistemde bilgi amaçlı bir çakışma görünmüyor."
            />
          </SectionCard>
        </>
      ) : null}
    </Layout>
  );
}

export default MakinaExcelImportKontrolPage;
